export const otherSkills = [
  "mongoDB",
  "redis",
  "restful-API",
  "sass",
  "puppeteer",
  "mustache.js",
  "JWT",
  "oauth",
  "git",
  "gitLab",
  "github",
  "AWS",
  "confluence",
  "agile-development",
  "JIRA",
  "XLR",
  "test-driving-development",
  "postman",
  "bcrypt",
  "middleware-protection",
  "alibaba-ECS",
  "linux",
  "segment",
  "sentry",
];
